import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-dry-run-transaction/page.tsx");
